var React = require('react');

function Shield (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M158.3 36.1c-14.4 0-40.5-3-58.3-22.1-17.9 19.1-43.9 22.1-58.3 22.1-6.6 0-10.7-.6-10.7-.6v75.2c0 44.3 69 75.2 69 75.2s69-30.9 69-75.2V35.5s-4.1.6-10.7.6zm.2 74.7c0 28.3-38.9 53.6-58.5 63.4-19.6-9.7-58.5-35-58.5-63.4V46.9h.2c13.9 0 38.6-2.6 58.3-18.4 19.8 15.8 44.4 18.4 58.3 18.4h.2v63.9zm-88.9 16.6h60.6v-10.8H69.6v10.8zm0-25.2h60.6V91.5H69.6v10.7zm0-25.2h60.6V66.3H69.6V77z","fill":"currentColor","data-color":"1"})));
}

Shield.defaultProps = {"preserveAspectRatio":"xMidYMid meet","id":"comp-k95ehgc7svgcontent","data-bbox":"31 14 138 171.9","viewBox":"31 14 138 171.9","data-type":"color","role":"img"};

module.exports = Shield;

Shield.default = Shield;
